export default __webpack_public_path__ + "static/media/sycamore4.9955db1c.jfif";